window.US_PANEL = window.US_PANEL || {
 "summaryOnly": true,
 "total": 185,
 "categories": [
  {
   "name": "Breast cancer",
   "count": 13,
   "color": "#33382C"
  },
  {
   "name": "Colorectal cancer",
   "count": 16,
   "color": "#3D4334"
  },
  {
   "name": "Other cancer",
   "count": 40,
   "color": "#484F3D"
  },
  {
   "name": "Cardiomyopathy",
   "count": 38,
   "color": "#535C46"
  },
  {
   "name": "Heart rhythm disorders",
   "count": 12,
   "color": "#606951"
  },
  {
   "name": "Other heart and circulation",
   "count": 37,
   "color": "#6D765D"
  },
  {
   "name": "Blood and immune health",
   "count": 8,
   "color": "#7B846A"
  },
  {
   "name": "Brain, nerve and muscle health",
   "count": 4,
   "color": "#8A927A"
  },
  {
   "name": "Liver and kidney health",
   "count": 7,
   "color": "#9AA28B"
  },
  {
   "name": "Hormones and metabolism",
   "count": 6,
   "color": "#ACB39F"
  },
  {
   "name": "Skin, bones and connective tissue",
   "count": 1,
   "color": "#C0C5B4"
  },
  {
   "name": "Diabetes",
   "count": 3,
   "color": "#D6D9CD"
  }
 ],
 "tags": [
  {
   "name": "Skin cancer",
   "count": 6
  },
  {
   "name": "Prostate cancer",
   "count": 10
  },
  {
   "name": "Ovarian cancer",
   "count": 12
  },
  {
   "name": "Gastric cancer",
   "count": 10
  }
 ]
};
